export var nudgeButtonView = function (state) {
    switch (state) {
        case 'sending':
            return { label: 'Sending…', disabled: true };
        case 'sent':
            return { label: 'Sent', disabled: true };
        case 'rate_limited':
            return { label: 'Try again soon', disabled: true };
        case 'error':
            return { label: 'Try again', disabled: false };
        case 'idle':
        default:
            return { label: 'Nudge', disabled: false };
    }
};
